@if (store.active || store.restored) {
  <div
    #surfaceEl
    class="region-chat-surface"
    data-testid="region-chat-surface"
    [style.left.px]="canvasOffsetX"
    [style.top.px]="canvasOffsetY"
    [style.width.px]="canvasWidth"
    [style.height.px]="canvasHeight"
  >
    <svg class="region-chat-svg" [attr.width]="canvasWidth" [attr.height]="canvasHeight" aria-hidden="true">
      @if (store.active && store.polygon.length) {
        <path class="region-outline-halo" [attr.d]="outlinePath" />
        <path class="region-outline" data-testid="region-chat-outline" [attr.d]="outlinePath" />
      }
      @if (!store.active && store.restored) {
        <path class="region-outline-halo" [attr.d]="restoredPath" />
        <path
          class="region-outline restored"
          data-testid="region-chat-restored-outline"
          [class.stale]="store.restored.stale"
          [attr.d]="restoredPath"
        />
      }
    </svg>
  </div>
}
